import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=f7956282&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=f7956282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7956282",
  null
  
)

export default component.exports